import { AddressHistory } from "../components/addressHistory";

export function AddressHistoryPage() {
  return <AddressHistory />;
}
